export const PriceActionTypes = {
  SET_FILTERED_PRICES: 'SET_FILTERED_PRICES',
  UPDATE_PRICE: 'UPDATE_PRICE',
  UPDATE_PRICE_COMPLETE: 'UPDATE_PRICE_COMPLETE',
  BATCH_UPDATE: 'BATCH_UPDATE',
};
